import React, { useEffect } from 'react';
import { PageTile } from './PageTile';
import { connect } from "react-redux";
import { Mixpanel } from "../../helpers";

function GridView(props) {



  const { dealjacket, deal_jacket_id, toggleCarousel, setCurrentPageIndex, setCurrentJacketPages, authentication, org } = props;
  const jwt = authentication.jwt;
  const user_id = authentication?.user?.user_id;
  const org_id = org?.current_org_id;
  const current_org = org.list?.filter(
    (o) => o.org_id == org_id
  )[0];
  const limit_pipeline = current_org?.limit_pipeline;

  useEffect(() => {
    const custom_properties = {
      'tt_user_id': user_id,
      'tt_org_id': org_id,
      'tt_deal_jacket_id': deal_jacket_id
    };
    Mixpanel.track('GridView', custom_properties);
  }, [deal_jacket_id, org_id, user_id]);





  const tiles = dealjacket?.map((page, i) => (
    <PageTile dealjacket={dealjacket}
      page={page} toggleCarousel={toggleCarousel} setCurrentPageIndex={setCurrentPageIndex} limit_pipeline={limit_pipeline}
      setCurrentJacketPages={setCurrentJacketPages} jwt={jwt} key={page.page_id + ':' + page.group_id + ':' + page.page_type_id} />
  ));

  return (

    <div className="tileContainer leftColumn">
      {tiles}
    </div>

  )
}

function mapStateToProps(state) {
  const { authentication, org } = state;
  return {
    authentication,
    org
  };
}

const connectedGridView = connect(mapStateToProps)(
  GridView
);
export { connectedGridView as GridView };
